import { useState } from 'react'
import { ChangeEvent, Dispatch, SetStateAction } from 'react'
import { useMediaQuery, useTheme, SelectChangeEvent } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { SearchBar, FormSelect } from 'src/components'
import { useImpactTypesSelectionOption, useUnSdgSelectionOption } from 'src/hooks'
import { IFilter } from 'src/components/filter/types/filter.types'

import { useStyles } from './styles'
import { SuggestButton } from './suggest-button.component'
import { FilterOffIcon } from 'src/assets/icons/v2/FilterOffIcon'
import { FilterIcon } from 'src/assets/icons/v2/FilterIcon'

interface IImpactsLibraryFilterProps {
  filter: IFilter
  setFilter: Dispatch<SetStateAction<IFilter>>
}

const ImpactsLibraryFilter = ({ filter, setFilter }: IImpactsLibraryFilterProps) => {
  const [t] = useTranslation()
  const { items } = useImpactTypesSelectionOption()
  const { items: unSdgItems } = useUnSdgSelectionOption()
  const [opened, setOpened] = useState<boolean>()
  const theme = useTheme()
  const isSmallTablet = useMediaQuery(theme.breakpoints.down('tablet_s'))
  const classes = useStyles()

  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value
    setFilter((prev) => ({ ...prev, query }))
  }

  const handleTypeChange = (e: SelectChangeEvent) => {
    const type = e.target.value
    setFilter((prev) => ({ ...prev, type }))
  }

  const handleUnSdgChange = (e: SelectChangeEvent) => {
    const unSdg = e.target.value
    setFilter((prev) => ({ ...prev, unSdg }))
  }
  const handleFilterOpen = () => {
    setOpened((prev) => !prev)
  }

  return (
    <div className={classes.filterWrapper}>
      <SearchBar
        search={filter.query}
        handleSearchChange={handleSearchChange}
        inputPlaceholder={t('impacts-library-search-input.v')}
      />
      <div onClick={handleFilterOpen} className={classes.button}>
        {opened ? <FilterIcon size={24} /> : <FilterOffIcon size={24} />}
      </div>
      {!isSmallTablet && (
        <div className={classes.suggestButtonWrapper}>
          <SuggestButton />
        </div>
      )}
      <div className={classes.filterInner}>
        {opened && (
          <div className={classes.filterSelect}>
            <FormSelect
              noClear={false}
              setFilter={setFilter}
              paramName="type"
              handleChange={handleTypeChange}
              value={String(filter.type)}
              selectName={t('impact-types-select-name.v')}
              items={items}
              filter={filter}
            />
            <FormSelect
              noClear={false}
              setFilter={setFilter}
              paramName="unSdg"
              handleChange={handleUnSdgChange}
              value={String(filter.unSdg)}
              selectName={t('un-sdg-title-abbr.v')}
              items={unSdgItems}
              filter={filter}
            />
          </div>
        )}
      </div>
      {isSmallTablet && (
        <div className={classes.suggestButtonWrapper}>
          <SuggestButton />
        </div>
      )}
    </div>
  )
}

export { ImpactsLibraryFilter }
